export var FinancialBotStatusEnum;
(function (FinancialBotStatusEnum) {
    FinancialBotStatusEnum["IDLE"] = "IDLE";
    FinancialBotStatusEnum["RUNNING"] = "RUNNING";
})(FinancialBotStatusEnum || (FinancialBotStatusEnum = {}));
//# sourceMappingURL=financial-bot-status.enum.js.map